(() => {
  if (window.fumerBackorderPreferenceBound) return;
  window.fumerBackorderPreferenceBound = true;

  const savePreference = async (input, silent = false) => {
    const fieldset = input.closest('.fumer-shipping-preference');
    const status = fieldset?.querySelector('.fumer-shipping-preference__status');
    const inputs = fieldset?.querySelectorAll('[data-shipping-preference]') || [];

    inputs.forEach((radio) => (radio.disabled = true));
    if (status && !silent) status.textContent = 'Saving preference…';

    try {
      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: { 'Back-order shipping preference': input.value },
        }),
      });

      if (!response.ok) throw new Error('Unable to save preference');
      if (fieldset) fieldset.removeAttribute('data-needs-save');
      if (status && !silent) status.textContent = 'Preference saved.';
    } catch (error) {
      if (status) status.textContent = 'We could not save that choice. Please try again.';
    } finally {
      inputs.forEach((radio) => (radio.disabled = false));
    }
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-shipping-preference]')) savePreference(event.target);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.fumer-shipping-preference[data-needs-save]').forEach((fieldset) => {
      const checked = fieldset.querySelector('[data-shipping-preference]:checked');
      if (checked) savePreference(checked, true);
    });
  });
})();
